module.exports = __webpack_public_path__ + "static/media/paz-place.f0ace720.png";